import { DefaultModel } from '../framework/default.model';

export class Notificacao extends DefaultModel {

  private token: string;
  private titulo: string;
  private onClick: Function;

  setToken(token: string): Notificacao {
    this.token = token;
    return this;
  }

  getToken(): string {
    return this.token;
  }

  gerarTokenAutomatico() {
    const _token = Math.random();
    this.setToken(_token.toString());
  }

  setOnClick(onClick: Function): Notificacao {
    this.onClick = onClick;
    return this;
  }

  getOnClick(): Function {
    return this.onClick;
  }

  execOnClick(): void {
    this.onClick();
  }

  getTitulo(): string {
      return this.titulo;
  }

  setTitulo(titulo: string): Notificacao {
      this.titulo = titulo;
      return this;
  }
}
